import { Injectable } from "@angular/core";
import { Select } from "@ngxs/store";
import { SystemStore } from "@/common/stores/system.store";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user: any = null;
  authenticated: boolean = false;

  @Select(SystemStore.user) user$!: Observable<any>;
  @Select(SystemStore.isAuthenticated) isAuthenticated$!: Observable<boolean>;

  constructor() {
    this.user$
      .subscribe((user: any) => this.user = user);

    this.isAuthenticated$
      .subscribe((authenticated) => this.authenticated = authenticated);
  }

  isAuthorized(roles: any[]): boolean {
    return this.isAuthorizedForUser(this.user, roles);
  }

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  isAuthorizedForUser(user: any, roles: any[]): boolean {
    const authRoles = Array.isArray(roles) ? roles : [];
    if (user) {
      return authRoles.length === 0 || authRoles.includes(user ? user.role : "");
    }

    if (!user && authRoles.length === 0) {
      return true;
    }
    return false;
  }

}
